import LoanRibbenBox from './LoanRibbenBox';
import LeadDetailTabs from '../detail/LoanFiledTabs';
import { useNavigate, useParams } from 'react-router-dom';
import React, { useEffect, useState } from "react";
import { updateLeadDetailsInStore, setInboundPaymentFromResponse, fetchLeadData, fetchDocuments, fetchQuoteDetails } from '../../../store/slices/insurance';
import { getDocumentListing, getStateList } from '../../../store/slices/common';
import FullPageLoader from '../../../common/FullPageLoader';
import { getMasterConfig } from '@src/store/slices/common';
import { useDispatch, useSelector } from 'react-redux';
import { INBOUND_PAYMENT_FROM_CUSTOMER, INBOUND_PAYMENT_FROM_SALES_TEAM, INBOUND_PAYMENT_FROM_BROKER, STATUS_SUB_STATUS, API_TYPES, INBOUND_PAYMENT_FROM_OTO_INSURANCE, INBOUND_PAYMENT_FROM_INSURANCE_PARTNER, APP_TYPE_AGENCY,INS_INSURANCE_ID_STAGE,COUNTRY_CODE,STANDALONE_RENEWALS,LEAD_TYPE_CRM,APP_TYPE_RENEWAL,APP_TYPE_STANDALONE,STATUS_SUCCESS } from "@src/config/constant";
import LeadDetailTabsId from '../detail/LoanFiledTabsId';



export default function Details(props: any): ReturnType<React.FC> {
    const queryParams = useParams();
    const dispatch: any = useDispatch();
    const insuranceState = useSelector((state: any) => state.insurance);
    const commonState = useSelector((state: any) => state.common);

    let [leadHashId, setLeadHashId] = useState<string>();
    let [loading, setLoading] = useState<boolean>(false);

    //let [apiCallFlag, setApiCallFlag] = useState(false);
    let [renewalsSource, setRenewalsSource] = useState<number>(0);
    const leadSource = useSelector((state: any) => state.common.common?.lead_source);

    const navigate = useNavigate();

    useEffect(() => {
        return () => {
            dispatch(updateLeadDetailsInStore({}));
            dispatch(setInboundPaymentFromResponse(''));

        }
    // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (!Array.isArray(leadSource)) return;
        const standaloneRenewals = leadSource.find((src: any) => src.slug === STANDALONE_RENEWALS);
        if (standaloneRenewals) {
            setRenewalsSource(+standaloneRenewals.value);
        }
        getDetails();
    // eslint-disable-next-line
    }, [leadSource]);

    useEffect(() => {
        if (Object.keys(commonState.common).length === 0) {
            dispatch(getMasterConfig());
        }
        if ((commonState.state).length === 0) {
            dispatch(getStateList());
        }
        
    }, [dispatch, commonState,commonState.state,commonState.city]);


    const getDetails = async () => {
        setLoading(true);
        if (queryParams && queryParams.id) {
            setLeadHashId(queryParams.id);
            const documents:any = await fetchAllDocuments();
           
                    (fetchLeadData({ "lead_id": queryParams.id, apiType: API_TYPES['customerData'] })).then(async (res: any) => {
                
                setLoading(false);
                if (res && res.status === STATUS_SUCCESS) {
                    let isPageAccess = false;
                    
                    if(res.data && !Object.keys(res.data).length) {
                        navigate('/not-found')
                        return false
                    }
                    if (queryParams && queryParams.type && res.data) {
                        if (queryParams.type === "sent-to-insurance-broker" && res.data.sub_status_id >= STATUS_SUB_STATUS['subStatus']['application_created']) {
                            isPageAccess = true;
                        }else if (queryParams.type === "insurance-policy-generated" && res.data.sub_status_id >= STATUS_SUB_STATUS['subStatus']['sent_to_insurance_broker']) {
                            isPageAccess = true;
                        } else if (queryParams.type === "policy-terms-finalized" && res.data.sub_status_id >= STATUS_SUB_STATUS['subStatus']['policy_generated']) {
                            isPageAccess = true;
                        } else if (queryParams.type === "insurance-policy-shared" && (res.data.sub_status_id >= STATUS_SUB_STATUS['subStatus']['policy_shared'] || (res.data.prev_status_sub_status_ids || '').indexOf(`${STATUS_SUB_STATUS['status']['insurance_policy']}-${STATUS_SUB_STATUS['subStatus']['policy_terms_finalized']}`) !== -1)) {
                            isPageAccess = true;
                        } else if (queryParams.type === "payment-customer" && res.data.sub_status_id >= STATUS_SUB_STATUS['subStatus']['payment_from_customer']) {
                            isPageAccess = true;
                        } else if (queryParams.type === "payment-sales-team" && res.data.sub_status_id >= STATUS_SUB_STATUS['subStatus']['payment_from_sales_team']) {
                            isPageAccess = true;
                        } else if (queryParams.type === "insurance-premium-payment" && res.data.sub_status_id >= STATUS_SUB_STATUS['subStatus']['policy_shared']) {
                            isPageAccess = true;
                        } else if (queryParams.type === "incentive-payment" && res.data.sub_status_id >= STATUS_SUB_STATUS['subStatus']['payment_from_customer']) {
                            isPageAccess = true;
                        } else if (queryParams.type === "insurer-partner-payment" && res.data.sub_status_id >= STATUS_SUB_STATUS['subStatus']['payment_to_sales_team']) {
                            isPageAccess = true;
                        } 
                        // else if (queryParams.type === "payment-broker" && res.data.sub_status_id >= STATUS_SUB_STATUS['subStatus']['payment_from_broker']) {
                        //     isPageAccess = true;
                        else if (queryParams.type === "payment-to-broker" && res.data.sub_status_id >= STATUS_SUB_STATUS['subStatus']['payment_from_customer']) {
                            isPageAccess = true;
                        } else if (queryParams.type === "payment-to-sales-team" && res.data.sub_status_id >= STATUS_SUB_STATUS['subStatus']['payment_from_customer']) {
                            isPageAccess = true;
                        } 
                        // else if (queryParams.type === "payment-from-customer-to-partner-broker" && res.data.pay_from_cust_to_partner_broker_id) {
                        //     isPageAccess = true;
                        // } else if (queryParams.type === "payment-from-agency-to-oto-insurance" && res.data.prev_status_sub_status_ids.indexOf(`${STATUS_SUB_STATUS['status']['insurance_payment']}-${STATUS_SUB_STATUS['subStatus']['payment_from_agency_to_oto_insurance']}`) !==-1) {
                        //     isPageAccess = true;
                        // } else if (queryParams.type === "payment-from-oto-to-insurance-partner" && res.data.prev_status_sub_status_ids.indexOf(`${STATUS_SUB_STATUS['status']['insurance_payment']}-${STATUS_SUB_STATUS['subStatus']['payment_from_oto_to_insurance_partner']}`) !==-1) {
                        //     isPageAccess = true;
                        // } else if (queryParams.type === "payment-from-insurance-partner-to-oto" && res.data.prev_status_sub_status_ids.indexOf(`${STATUS_SUB_STATUS['status']['insurance_payment']}-${STATUS_SUB_STATUS['subStatus']['payment_from_insurance_partner_to_oto']}`) !==-1) {
                        //     isPageAccess = true;
                        // } else if (queryParams.type === "payment-from-agency-to-insurance-partner" && res.data.prev_status_sub_status_ids.indexOf(`${STATUS_SUB_STATUS['status']['insurance_payment']}-${STATUS_SUB_STATUS['subStatus']['payment_from_agency_to_insurance_partner']}`) !==-1) {
                        //     isPageAccess = true;
                        // } else if (queryParams.type === "referral-fee-payout" && res.data.prev_status_sub_status_ids.indexOf(`${STATUS_SUB_STATUS['status']['incentive_payment']}-${STATUS_SUB_STATUS['subStatus']['referral_fee_payout']}`) !==-1) {
                        //     isPageAccess = true;
                        // }
                    }

                    let allDocuments = documents?.data || []
                    let updatedLeadData = { ...insuranceState.leadDetail, ...res.data, images: allDocuments, customer_api_call: true };
                    dispatch(updateLeadDetailsInStore(updatedLeadData))

                    const quoteResponse: any = await fetchQuoteDetails({ lead_id: queryParams.id });
                    if (quoteResponse && quoteResponse.status === STATUS_SUCCESS && quoteResponse.data) {
                        dispatch(updateLeadDetailsInStore({
                            ...updatedLeadData,
                            ...quoteResponse.data
                        }))
                    }

                    // setInsuranceDetails(res.data);
                    
                    const payload:any = {
                        leadId: queryParams.id,
                        source: 'web',
                    };
                    if(INS_INSURANCE_ID_STAGE) delete payload.leadId

                    //** Filter gate document images based on policyholder type, vehicle condition ID, existing policy, vehicle photos, and comments
                    if(INS_INSURANCE_ID_STAGE){
                        payload.lead_id = res.data?.id;
                    }
                    //** Filter gate document images based on policyholder type, vehicle condition ID, existing policy, vehicle photos, and comments


                    if(res?.data?.application_type_id && res.data.application_type_id === APP_TYPE_AGENCY) {
                        payload['application_type_id'] = APP_TYPE_AGENCY
                    }
                    if(INS_INSURANCE_ID_STAGE) delete payload.application_type_id

                    dispatch(getDocumentListing(payload));
                    let getInboundPaymentFrom = res.data?.inbound_payment_from || res.data?.pay_from_cust_to_partner_broker_payment_from;
                    if (+getInboundPaymentFrom === INBOUND_PAYMENT_FROM_CUSTOMER) {
                        getInboundPaymentFrom = "customer";
                    } else if (+getInboundPaymentFrom === INBOUND_PAYMENT_FROM_SALES_TEAM) {
                        getInboundPaymentFrom = "sales_team";
                    } else if (+getInboundPaymentFrom === INBOUND_PAYMENT_FROM_BROKER) {
                        getInboundPaymentFrom = "broker";
                    } else if (+getInboundPaymentFrom === INBOUND_PAYMENT_FROM_OTO_INSURANCE) {
                        getInboundPaymentFrom = "oto_insurance";
                    } else if (+getInboundPaymentFrom === INBOUND_PAYMENT_FROM_INSURANCE_PARTNER) {
                        getInboundPaymentFrom = "insurance_partner";
                    }
                    if (getInboundPaymentFrom) {
                        dispatch(setInboundPaymentFromResponse(getInboundPaymentFrom));
                    }

                    // IF NOT AUTHORIZED 
                    let standaloneRenewals = 0;
                    if (leadSource && Array.isArray(leadSource)) {
                        const standaloneRenewalsdata = leadSource.find((src: any) => src.slug === STANDALONE_RENEWALS);
                        standaloneRenewals = +standaloneRenewalsdata?.value;
                    }
                    const isUnderVerificationType = (+res.data.lead_type === LEAD_TYPE_CRM && COUNTRY_CODE === 'ph') || (+res.data.application_type_id === APP_TYPE_RENEWAL) || (+res.data.application_type_id === APP_TYPE_STANDALONE && +res.data.lead_source === standaloneRenewals);
                    if(queryParams && queryParams.type && !isPageAccess && isUnderVerificationType && COUNTRY_CODE == 'ph'){
                        navigate(`/details/under-verification/${queryParams.id}`);
                        return false;
                    }
                    else if (queryParams && queryParams.type && !isPageAccess && !["personal-details", "residential-details", "vehicle-details"].includes(queryParams.type)) {
                        navigate(`/details/personal-details/${queryParams.id}`);
                        return false;
                    }

                    setLoading(false);

                    // setLeadDetailUpdated(true)

                }
            }).catch((err: any) => {
                setLoading(false)
                // setLeadDetailUpdated(true)

            });
        }
    }

    const fetchAllDocuments = async () => {
        if (queryParams && queryParams.id) {
            const result: any = COUNTRY_CODE !== 'id' ? (insuranceState?.leadDetail?.images || await fetchDocuments({ lead_id: queryParams.id })):await fetchDocuments({ lead_id: queryParams.id })
            return result
        }
        return null
    }

    return (
        <div>
            <FullPageLoader show={loading} />
            <div className="container-fluid">
                <LoanRibbenBox />
                {
                   (COUNTRY_CODE==='id')?  <LeadDetailTabsId getDetails={() => getDetails()} leadHashId={leadHashId} />: <LeadDetailTabs getDetails={() => getDetails()} leadHashId={leadHashId} standaloneRenewalsSource={renewalsSource}/>
                }
            </div >
        </div>
    )

}

